import { useTranslation } from "react-i18next"
import { extensionApiState } from "./StateSelectors"
import { useRecoilValue } from "recoil"

const DeprecatedConfig = () => {
  const { t } = useTranslation("common") // Get t from the hook
  const extensionApi = useRecoilValue(extensionApiState)
  return (
    <div
      className="d-flex h-100 flex-column justify-content-center align-items-center text-center text-muted"
      data-testid="deprecatedConfigDiv"
    >
      <div
        className="bg-gray_0 d-block rounded d-flex justify-content-center align-items-center mb-1"
        style={{ width: "192px", height: "192px" }}
      >
        <i className="icon-font i64 tc-icon-error-alt"></i>
      </div>
      <h1 className="mb-1">{t("deprecatedConfig.title")}</h1>
      <p>{t("deprecatedConfig.message")}</p>
      <button
        className="button primary d-none d-lg-flex"
        onClick={() => {
          extensionApi?.ui.setActiveMenuItem("objectmodelconfig")
        }}
        data-testid="new-object-model"
      >
        {t("deprecatedConfig.button")}
      </button>
    </div>
  )
}

export default DeprecatedConfig
